export const DUMMY_COMPANY = {
  id: "demo-company",
  name: "Grand Palm Hotel",
  slogan: "In-room dining and guest services",
  logo: null,
  phone: "+94 11 234 5678",
  averageRating: 4.6,
  totalRatings: 128,
  district: "Colombo",
  country: "Sri Lanka",
};

export const DUMMY_OFFERS = [
  {
    id: "demo-offer-1",
    isActive: true,
    name: "Sunset cocktail",
    description: "Buy one mocktail, get the second half price after 5 PM.",
    Category: { name: "Tonight" },
  },
];

export const DUMMY_MENU = [
  {
    id: "cat-breakfast",
    name: "Breakfast",
    displayOrder: 1,
    MenuItems: [
      {
        id: "item-eggs",
        name: "Eggs Benedict",
        description: "Poached eggs, hollandaise, toasted muffin",
        basePrice: "18.00",
        isActive: true,
        isVegetarian: true,
        isVegan: false,
        isSpicy: false,
        image: null,
        ItemVariations: [],
        ModifierOptions: [],
      },
      {
        id: "item-fruit",
        name: "Tropical fruit bowl",
        description: "Pineapple, mango, passion fruit, mint",
        basePrice: "9.50",
        isActive: true,
        isVegetarian: true,
        isVegan: true,
        isSpicy: false,
        image: null,
        ItemVariations: [],
        ModifierOptions: [],
      },
    ],
  },
  {
    id: "cat-mains",
    name: "Mains",
    displayOrder: 2,
    MenuItems: [
      {
        id: "item-club",
        name: "Club sandwich",
        description: "Chicken, bacon, lettuce, fries",
        basePrice: "16.00",
        isActive: true,
        isVegetarian: false,
        isVegan: false,
        isSpicy: false,
        image: null,
        ItemVariations: [
          { id: "var-club-reg", name: "Regular", price: "16.00", displayOrder: 1 },
          { id: "var-club-large", name: "Large", price: "21.00", displayOrder: 2 },
        ],
        ModifierOptions: [],
      },
      {
        id: "item-curry",
        name: "Coconut fish curry",
        description: "Catch of the day, steamed rice, sambol",
        basePrice: "24.00",
        isActive: true,
        isVegetarian: false,
        isVegan: false,
        isSpicy: true,
        image: null,
        ItemVariations: [],
        ModifierOptions: [],
      },
      {
        id: "item-pasta",
        name: "Garden pasta",
        description: "Tomato, basil, roasted vegetables",
        basePrice: "14.00",
        isActive: true,
        isVegetarian: true,
        isVegan: true,
        isSpicy: false,
        image: null,
        ItemVariations: [],
        ModifierOptions: [],
      },
    ],
  },
  {
    id: "cat-drinks",
    name: "Drinks",
    displayOrder: 3,
    MenuItems: [
      {
        id: "item-lime",
        name: "Fresh lime soda",
        description: "Sweet, salt, or mixed",
        basePrice: "4.50",
        isActive: true,
        isVegetarian: true,
        isVegan: true,
        isSpicy: false,
        image: null,
        ItemVariations: [],
        ModifierOptions: [],
      },
    ],
  },
];

export const dummyTableFor = (tableId, typeOverride) => ({
  id: tableId || "demo-room",
  tableNumber: "412",
  type: typeOverride === "table" ? "table" : "room",
  location: "Ocean Wing, Floor 4",
  capacity: 2,
});

export const withTimeout = (promise, ms = 4000) =>
  Promise.race([
    promise,
    new Promise((_, reject) => {
      setTimeout(() => reject(new Error("timeout")), ms);
    }),
  ]);
